
 import { Pipe, PipeTransform } from '@angular/core';
import { Question } from '../../models/question.model';
import { Topic } from '../../models/topic.model';

 @Pipe({
     name: 'filtertopics' 
 })
 export class FilterTopicsPipe implements PipeTransform {
     transform(items: Topic[],filter: string ): Topic[] {
         if (!items || !filter) {
             return items;
         }
         
         return items.filter(item => item.idTopic != filter);
     }
 }